export default __webpack_public_path__ + "assets/images/94ccf474de4848a7466afefe17b36378.jpg";